let apiDir = 'request/api'
const apiFileList = require.context('./api', true, /\.js$/)
let apiList = {}
let files = apiFileList.keys()
//动态加载API的文件
files.forEach(paths => {
  let file = paths.replace('./', '')
  let fileName = file.substring(0, file.length - 3)
  let content = require(`@/${apiDir}/${file}`)
  apiList[fileName] = content.default
})
// console.log('API', apiList)
export default apiList
